import * as React from "react";
import dynamic from "next/dynamic";
import { IArticle, ICategory } from "../../faq.machine";

const Desktop = dynamic(async () => {
  return (await import("./Desktop")).Desktop;
});

const Mobile = dynamic(async () => {
  return (await import("./Mobile")).Mobile;
});

interface IDynamicFaqProps {
  activeCategoryId: string | undefined;
  selectCategory(id: string): void;
  categories: ICategory[];
  articles: IArticle[];
}

export function ActiveFaq({
  selectCategory,
  activeCategoryId,
  categories,
  articles,
}: IDynamicFaqProps) {
  return (
    <>
      <div className="hidden from-tablet:block" data-test-id="active-desktop">
        <Desktop
          activeCategoryId={activeCategoryId}
          articles={articles}
          categories={categories}
          selectCategory={selectCategory}
        />
      </div>
      <div className="hidden only-mobile:block" data-test-id="active-mobile">
        <Mobile
          activeCategoryId={activeCategoryId}
          articles={articles}
          categories={categories}
          selectCategory={selectCategory}
        />
      </div>
    </>
  );
}
